export default __webpack_public_path__ + "static/media/img_step_appliance01.4b1a2836.jpg";